import React, { useEffect, useState } from "react";
import LayoutContentWrapper from "../../components/Layout/LayoutContentWrapper/LayoutContentWrapper";
import ContentHeader from "../../components/Layout/Content/ContentHeader/ContentHeader";
import { useAppSelector } from "../../hooks/redux";
import { getLanguage } from "../../store/selectors/appSelector";
import { UXPrice } from "../../enums/UXText/UXPrice";
import { UIText } from "../../enums/UIText/UIText";
import styles from "./Price.module.css";
import BasicModules from "./Modules/BasicModules/BasicModules";
import AdditionalModules from "./Modules/AdditionalModules/AdditionalModules";
import { EnumPages } from "../../enums/EnumPages";
import AdministrationModules from "./AdministrationModules/AdministrationModules";
import AdminContainer from "../../components/Utils/Admins/AdminContainer/AdminContainer";
import Buttons, { EnumColors } from "../../components/Utils/Buttons/Buttons/Buttons";
import { EnumLanguage } from "../../enums/EnumLanguage";
import { getTextByLanguage } from "../../enums/utils/getTextByLanguage";

const Price = () => {
	const language = useAppSelector(getLanguage);
	const [isEditMode, setIsEditMode] = useState<boolean>(false);

	useEffect(() => {
		document.title = `${UIText.nav.price[language]} - ${UIText.mis[EnumLanguage.ru]}`;
	}, [language]);

	return (
		<div className={styles.priceWrapper}>
			<LayoutContentWrapper>
				<ContentHeader
					title={getTextByLanguage(UIText.nav.price, language)}
					description={getTextByLanguage(UXPrice.description, language)}
					editable={true}
					pageName={EnumPages.price}
				/>
			</LayoutContentWrapper>
			<AdminContainer>
				<LayoutContentWrapper>
					<Buttons className={styles.editButton} color={EnumColors.white} onClick={() => setIsEditMode(!isEditMode)}>
						{isEditMode ? UXPrice.adminButtons.cancelEdit[EnumLanguage.ru] : UXPrice.adminButtons.editModules[EnumLanguage.ru]}
					</Buttons>
				</LayoutContentWrapper>
			</AdminContainer>
			{isEditMode ? (
				<AdministrationModules />
			) : (
				<>
					<BasicModules />
					{/* <AdditionalModules /> */}
				</>
			)}
		</div>
	);
};

export default Price;
